import styled, { css } from "styled-components";

export const ContactSection = styled.section`
  height: 100vh;
  min-height: 100vh;
`;

export const ContactSectionHeading = styled.h3`
  font-size: 3rem;
  margin: 2.5em auto 1.5em auto;
  text-align: center;
  text-decoration: underline;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const ContactFormWrapper = styled.div`
  background-color: #fff;
  box-shadow: 2.6px 5.1px 5.1px hsl(0deg 0% 0% / 0.42);
  border: 1px solid #ccc;
  padding: 2em;
  border-radius: 10px;
  max-width: 50%;
  margin: 0 auto;

  @media (max-width: 890px) {
    max-width: 90%;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  font-size: 1em;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  padding: 7px;
  outline: none;
  border-radius: 5px;
  border: 1px solid rgb(220, 220, 220);

  &:focus {
    border: 2px solid #00b4db;
  }
`;

export const TextArea = styled.textarea`
  max-width: 100%;
  min-width: 100%;
  width: 100%;
  max-height: 100px;
  min-height: 100px;
  padding: 7px;
  outline: none;
  border-radius: 5px;
  border: 1px solid rgb(220, 220, 220);
  font-family: "Open-Sans", sans-serif;

  &::placeholder {
    font-family: "Open-Sans", sans-serif;
  }

  &:focus {
    border: 2px solid #00b4db;
  }
`;

export const Label = styled.label`
  margin: 1rem 0 0.3rem 0;
  font-weight: 600;
`;

export const InputSubmit = styled(Input).attrs({ type: "submit" })`
  ${({ theme }) => css`
    background: ${theme.colors.buttonColor};
  `}
  color: #fff;
  font-weight: 600;
  font-size: 1em;
  margin-top: 2rem;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    color: #000;
  }
`;
